import script from "./boardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./boardHeader.vue?vue&type=script&setup=true&lang=js"

import "./boardHeader.vue?vue&type=style&index=0&id=14c5a98a&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c5a98a"]])

export default __exports__